import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { useEffect } from "react";

function DataGrid({ columns, data, otherAgGridProps }) {
  const onSortChanged = (e) => {
    e.api.refreshCells();
  };
  const gridRef = useRef();
  useEffect(() => {
    if (gridRef && gridRef.current && gridRef.current.columnApi) {
      gridRef.current.columnApi.getColumns();
    }
  }, [gridRef]);
  return (
    <div
      className="ag-theme-material"
      style={{ height: "100%", width: "100%" }}
    >
      <AgGridReact
        ref={gridRef}
        rowData={data || []}
        onSortChanged={onSortChanged}
        {...(otherAgGridProps ?? {})}
        defaultColDef={{
          flex: 1,
          filter: "agTextColumnFilter",
          sortable: true,
          resizable: true,
          minWidth: 300,
        }}
        columnDefs={
          [
            {
              headerName: "SrNo.",
              valueGetter: (node) =>
                node.data.srNo !== undefined ? node.data.srNo : node.node.rowIndex + 1,
              maxWidth: 80,
              filter: null,
              sortable: false,
            },
            ...columns.map(({ field, headerName, gridLayoutAttr }) => ({
              field,
              headerName,
              ...gridLayoutAttr,
            })),
          ] || []
        }
      ></AgGridReact>
    </div>
  );
}

export default DataGrid;
